const pluginConfig = {
  pluginId: "aws-s3-bucket-viewer",
  annotationKey: "newscorp.com/aws-s3-bucket-viewer"
};

export { pluginConfig };
//# sourceMappingURL=config.esm.js.map
